/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Machines_Control_ErrorInputs */

const vi_tea_machines_control_error = /** @type {(inputs: Tea_Machines_Control_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không gửi được lệnh, vui lòng thử lại`)
};

/**

* @param {Tea_Machines_Control_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_machines_control_error = /** @type {((inputs?: Tea_Machines_Control_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Machines_Control_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_machines_control_error(inputs)
});